import { render, staticRenderFns } from "./ExibirFoto.vue?vue&type=template&id=50c0fc8e&scoped=true&"
import script from "./ExibirFoto.vue?vue&type=script&lang=js&"
export * from "./ExibirFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0fc8e",
  null
  
)

export default component.exports